import { Popover } from "@/components/Popover/Popover";
import FlagIcon from "@medoma/components/icons/FlagIcon";
import { useLingui } from "@lingui/react/macro";
import { TextWithLineBreaks } from "@medoma/components/Text/Text";
import styles from "./FlagsPopover.module.scss";

export const FlagsPopover = ({ details }: { details: string }) => {
  const { t } = useLingui();

  return (
    <Popover
      trigger={{
        custom: (
          <div className={styles.flagIndicator}>
            <FlagIcon />
          </div>
        ),
        ariaLabel: t`Visa flaggningar`,
      }}
    >
      <TextWithLineBreaks>{details}</TextWithLineBreaks>
    </Popover>
  );
};
